import { RouteObject } from "react-router-dom";
import { ServicepartnerList } from "@/pages/admin/servicepartners/ServicepartnerList";
import { ServicepartnerDetail } from "@/pages/admin/servicepartners/ServicepartnerDetail";
import { ServicepartnerEdit } from "@/pages/admin/servicepartners/ServicepartnerEdit";
import { ServicepartnerImport } from "@/pages/admin/servicepartners/ServicepartnerImport";
import { ServicepartnerChangeRequest } from "@/pages/admin/servicepartners/ServicepartnerChangeRequest";

export const servicePartnersRoutes: RouteObject[] = [
  {
    id: "service-partners-list",
    index: true,
    element: <ServicepartnerList />,
  },
  {
    id: "service-partner-detail",
    path: ":id",
    element: <ServicepartnerDetail />,
  },
  {
    id: "service-partner-edit",
    path: ":id/edit",
    element: <ServicepartnerEdit />,
  },
  {
    id: "service-partner-change-request",
    path: ":id/change-request",
    element: <ServicepartnerChangeRequest />,
  },
  {
    id: "service-partner-import",
    path: "import",
    element: <ServicepartnerImport />,
  },
];
